export default __webpack_public_path__ + "static/media/exposure.6b359aab.svg";